import { render, staticRenderFns } from "./webrtc.vue?vue&type=template&id=04fd10d7&"
import script from "./webrtc.vue?vue&type=script&lang=js&"
export * from "./webrtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports